import React from 'react'
import Aside from './aside'

interface LayoutProps {
  children: React.ReactNode
  quarter: {
    edges: { node: { id: string; name: string; changelogs: Blog.AllPosts } }[]
  }
}

export default function Layout({ children, quarter }: LayoutProps) {
  return (
    <article className='grid pb-20 pt-3 lg:grid-cols-3 lg:gap-3 lg:px-20'>
      <div className='col-span-2'>
        <ul className='flex flex-col space-y-5 pt-4'>{children}</ul>
      </div>

      <div className='hidden pt-4 lg:block'>
        <Aside quarter={quarter} />
      </div>
    </article>
  )
}
